import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const portalApi = axios.create({ baseURL: API });
export const adminApi = axios.create({ baseURL: API });

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("portal_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (detail?.isAxiosError) return formatApiError(detail.response?.data?.detail ?? detail.message);
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Fetch a stored file as an object URL using the given token type.
export async function fetchBlobUrl(fileId, tokenKey = "portal_token") {
  const token = localStorage.getItem(tokenKey);
  const res = await axios.get(`${API}/files/${fileId}`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
  return URL.createObjectURL(res.data);
}
